import React, { Component } from "react";
import styles from "./Home.module.css";
import { Link } from "react-router-dom";
import Aux from "./../Auxiliary/Auxiliary";
import Modal from "./../Modal/Modal";
import Checkout from "./../Checkout/Checkout";
import Spinner from "./../Spinner/Spinner";

class Home extends Component {
  state = {
    getItemsCart: false,
    checkout: false,
    loading: false,
    orderedConfirmed: false,
  };

  confirmOrderHandler = () => {
    this.setState({ orderedConfirmed: true });
  };
  closeLoadingHandler = () => {
    this.setState({ loading: false });
  };
  openLoadingHandler = () => {
    this.setState({ loading: true });
  };
  getItemsCartHandler = () => {
    this.setState({ getItemsCart: true });
  };
  closeItemsCartHandler = () => {
    this.setState({ getItemsCart: false });
  };
  checkoutHandler = () => {
    this.setState({ checkout: true, getItemsCart: false });
  };
  closeCheckoutHandler = () => {
    this.setState({ checkout: false });
  };
  render() {
    let items = "No items present";
    if (this.props.cartItems.length > 0)
      items = (
        <Aux>
          <div className={styles.itemsPresent}>Items present in your cart:</div>
          {this.props.cartItems.map((item) => (
            <div className={styles.cartItem}>{item}</div>
          ))}
          <button onClick={this.checkoutHandler} className={styles.Button}>
            Checkout
          </button>
        </Aux>
      );
    return (
      <Aux>
        {this.state.getItemsCart ? (
          <Modal
            show={this.state.getItemsCart}
            modalClosed={this.closeItemsCartHandler}
          >
            <div className={styles.cartItems}>{items}</div>
          </Modal>
        ) : null}
        {this.state.checkout ? (
          <Modal
            show={this.state.checkout}
            modalClosed={this.closeCheckoutHandler}
          >
            <Checkout
              items={this.props.cartItems}
              loadStart={this.openLoadingHandler}
              loadEnd={this.closeLoadingHandler}
              checkoutClose={this.closeCheckoutHandler}
              confirmOrder={this.confirmOrderHandler}
            />
          </Modal>
        ) : null}
        {!this.state.loading ? (
          <div>
            <button
              onClick={this.getItemsCartHandler}
              className={styles.Button}
            >
              Cart: {this.props.cart}
            </button>
            <div className={styles.heading}>
              <div className={styles.heading_primary}>
                If You are Stuck in the sea
              </div>
              <div className={styles.heading_secondary}>
                We are here to help you!
              </div>
              <Link to="/needs" className={styles.letsGo}>
                Lets Go &#8594;
              </Link>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
        {this.state.orderedConfirmed ? (
          <Modal
            show={this.state.orderedConfirmed}
            modalClosed={this.getHomeHandler}
          >
            <div style={{ display: "flex", flexFlow: "column" }}>
              <div style={{ fontFamily: "Rock Salt, cursive" }}>
                Order Confirmed
              </div>
              <a href="/" className={styles.Button}>
                Home
              </a>
            </div>
          </Modal>
        ) : null}
      </Aux>
    );
  }
}
export default Home;
